import { ProviderChannels } from './ProviderChannels';
import {
  ByProvider,
  useCareTeamChannelGuids,
} from '../hooks/store/useChannelHooks';
import { Box, Divider, styled, Typography } from '@mui/material';
import { DividerProps } from '@mui/material/Divider';
import { useIntl } from 'react-intl';
import { usePatient } from '../hooks/store/usePatientHooks';
import { displayName } from '@xolv-mybrightlink/common';

type ChannelListProps = {
  patientGuid?: string;
  onSelect: (channelGuid: string) => void;
};

const PastConversationDivider = styled(Divider)<DividerProps>(() => ({
  '&.MuiDivider-root': {
    '&::before': {
      width: '0%',
    },
  },
}));

export const ChannelList = (props: ChannelListProps) => {
  const intl = useIntl();
  const patient = usePatient(props.patientGuid ?? '');
  const channelsByProvider = useCareTeamChannelGuids(props.patientGuid);
  const { active: activeChannels, readOnly: readOnlyChannels } =
    channelsByProvider;
  return (
    <Box
      className='hide-scrollbar'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <Typography sx={{ fontWeight: 600, px: 5, pb: 5 }}>
        {intl.formatMessage(
          { id: 'care-team.for' },
          { name: patient ? displayName(patient) : '' },
        )}
      </Typography>
      <ProviderChannelsSection
        byProviderChannels={activeChannels}
        onSelect={props.onSelect}
      />
      {readOnlyChannels.length ? (
        <Box>
          <PastConversationDivider
            textAlign='left'
            sx={{ padding: 4, fontSize: 14, color: '#898f9b' }}
          >
            {intl.formatMessage({ id: 'care-team.past-conversations' })}
          </PastConversationDivider>
        </Box>
      ) : null}
      <ProviderChannelsSection
        byProviderChannels={readOnlyChannels}
        onSelect={props.onSelect}
      />
    </Box>
  );
};

const ProviderChannelsSection = (props: {
  byProviderChannels: ByProvider[];
  onSelect: (channelGuid: string) => void;
}) => {
  return (
    <>
      {props.byProviderChannels.map((group) => {
        const { provider, channelGuids } = group;
        return (
          <ProviderChannels
            key={provider}
            name={provider}
            channelGuids={channelGuids}
            onSelect={props.onSelect}
          />
        );
      })}
    </>
  );
};
